/*
 * @Author: your name
 * @Date: 2022-03-02 22:09:09
 * @LastEditTime: 2022-03-16 16:54:08
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \pscd-portal-middle-office\packages\www\src\pages\personal\forgetpwd\locales.ts
 */
export const EnumPageMeta: IEnumPageMeta = {
    /** 页面名称 */
    title: "",
    login: false,
}
/**
 * 字段描述 枚举
 */
export enum EnumLocaleLabel {
    /** 姓名 */
    endpoint = "lowresetpsd.endpoint",
    imgCode = "lowresetpsd.imgCode",
    verificationCode = "lowresetpsd.verificationCode",
    oldPassword = "lowresetpsd.oldPassword",
    newPassword = "lowresetpsd.newPassword",
    repassword = "lowresetpsd.repassword",
    username = "lowresetpsd.username"
}
export enum EnumGender {

}
export default {
    en: {
        [EnumLocaleLabel.endpoint]: 'endpoint',
        [EnumLocaleLabel.imgCode]: 'imgCode',
        [EnumLocaleLabel.verificationCode]: 'verificationCode',
        [EnumLocaleLabel.oldPassword]: 'oldPassword',
        [EnumLocaleLabel.newPassword]: 'newPassword',
        [EnumLocaleLabel.repassword]: 'repassword',
        [EnumLocaleLabel.username]: 'username',
    },
    zh: {
        [EnumLocaleLabel.endpoint]: '手机号',
        [EnumLocaleLabel.imgCode]: '图形验证码',
        [EnumLocaleLabel.verificationCode]: '短信验证码',
        [EnumLocaleLabel.oldPassword]: '旧密码',
        [EnumLocaleLabel.newPassword]: '新密码',
        [EnumLocaleLabel.repassword]: '确认密码',
        [EnumLocaleLabel.username]: '登录账号',
    }
}